import {
  CLICKED_MARKER_ON_MAP,
  POINTER_ON_MAP,
  FETCH_ALL_MARKERS_ON_MAP,
  MAP_ACTION_LOADING,
} from "../actionTypes";

const initialState = {
  item: {}, // selected marker on map ka kg
  pointer: {}, // pointer so dr ka data new add fox map apw click htouk mae kg
  markers: [], // map apaw ka data twy
  loading: false,
};

export function markerReducer(state = initialState, action) {
  switch (action.type) {
    case CLICKED_MARKER_ON_MAP:
      return {
        ...state,
        item: action.payload,
      };
    case POINTER_ON_MAP:
      return {
        ...state,
        pointer: action.payload,
      };
    case FETCH_ALL_MARKERS_ON_MAP:
      return {
        ...state,
        markers: action.payload,
      };
    case MAP_ACTION_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}
